<template>
  <div>
    <BaseTitle :title="$t('content.assignment_title')" :yearPeriode="titleData" />
    <v-card class="pa-8 mb-6">
      <v-progress-circular class="text-center" v-if="loadingButton === true" indeterminate color="primary"></v-progress-circular>
      <v-row>
        <v-col cols="12" md="3" class="py-0">
          <div>
            <v-text-field v-model="search" :label="$t('search')" clearable @input="searchFilter($event)" v-if="viewItem === 1 && filterType === 1">
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
            <v-text-field
              v-model="search"
              :label="$t('search')"
              clearable
              @input="searchFilterList($event)"
              v-if="viewItem === 1 && filterType === 2"
            >
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
            <v-text-field v-model="search" :label="$t('search')" v-if="viewItem === 2">
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
          </div>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <div>
            <v-select :items="viewType" :label="$t('view')" v-model="viewItem" />
          </div>
        </v-col>
        <v-col cols="12" md="2" class="py-0" v-if="type !== 'school-advisor'">
          <template>
            <v-btn
              color="secondary"
              v-if="permissionButton('ROLE_ASSIGNMENT_CREATE') || permissionButton('ROLE_ASSIGNMENT_LITE_CREATE')"
              class="btn-primary-custom mt-3"
              @click="dialogGroup = true"
              >{{ $t('content.add_grup') }}</v-btn
            >
          </template>
        </v-col>
        <v-col cols="12" md="2" class="py-0" v-if="type !== 'school-advisor'">
          <template>
            <v-btn
              color="primary"
              v-if="permissionButton('ROLE_ASSIGNMENT_CREATE') || permissionButton('ROLE_ASSIGNMENT_LITE_CREATE')"
              class="btn-primary-custom mt-3 ml-5"
              @click="addAssignment"
              >{{ $t('content.add_assignment') }}</v-btn
            >
          </template>
        </v-col>
        <v-col cols="12" md="2" class="py-0" v-if="type !== 'school-advisor'">
          <template>
            <v-btn color="primary" class="btn-primary-custom mt-3 ml-10" :disabled="checkExport === false" outlined @click="getExport">{{
              $t('content.export')
            }}</v-btn>
          </template>
        </v-col>
      </v-row>
      <v-row v-if="viewItem === 1">
        <v-col cols="12" md="12" class="py-0">
          <v-radio-group row v-model="filterType">
            <h4 class="mr-16">{{ $t('filter') }}</h4>
            <v-radio :label="`${$t('content.view_group_assignment')}`" color="secondary" :value="1" class="compact-form" />
            <v-radio :label="`${$t('content.view_list_assignment')}`" color="secondary" :value="2" class="compact-form" />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card>
    <!-- view list box -->
    <div v-if="viewItem === 1 && filterType === 1">
      <v-card class="mb-5" v-for="grup in grupList" v-bind:key="grup.assignmentGroupId">
        <slide-box :value="true">
          <template #activator="{isOpen}">
            <div class="pa-5 d-flex justiy-space-between align-items section-header active">
              <div class="student-title">{{ grup.assignmentGroupName }}</div>
              <template>
                <div class="text-center ml-3" v-if="grup.assignmentGroupName != 'Ungroup'">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-white" class="mt-1" v-if="type !== 'school-advisor'" />
                      </span>
                    </template>
                    <v-list v-if="type !== 'school-advisor'">
                      <v-list-item v-for="(item, index) in dropDown" :key="index">
                        <v-list-item-title v-if="item.title === 'Edit' || item.title === 'Mengubah'" @click="editGrup(grup)" class="text-dropdown">{{
                          item.title
                        }}</v-list-item-title>
                        <v-list-item-title
                          v-if="
                            (grup.assignments.length === 0 && item.title === 'Delete') || (grup.assignments.length === 0 && item.title === 'Hapus')
                          "
                          @click="dialogDelete = true"
                          class="text-dropdown-delete"
                          >{{ item.title }}</v-list-item-title
                        >
                        <v-list-item-title
                          v-if="(grup.assignments.length > 0 && item.title === 'Delete') || (grup.assignments.length > 0 && item.title === 'Hapus')"
                          class="text-dropdown-grey"
                          >{{ item.title }}</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
              <v-spacer />
              <div class="header-circle mr-10" v-if="grup.assignmentGroupName != 'Ungroup'">
                <span class="header-circle-text">{{ grup.assignmentPercent }}% {{ $t('content.of_total') }} </span>
              </div>
              <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </div>
          </template>
          <template>
            <div class="assignment-content">
              <div v-for="item in grup.assignments" :key="item.assignmentId" :item="item">
                <!-- new feature -->
                <v-row class="border-item">
                  <v-col md="1" align="center">
                    <div class="pa-5">
                      <svg-icon v-if="item.lock === true" icon="lock" class="red--text assigment-icon" />
                      <svg-icon v-if="item.lock === false" icon="gembok" class="assigment-icon" />
                    </div>
                  </v-col>
                  <v-col md="10" class="mt-5">
                    <div class="d-block mb-2">
                      <h3 class="d-inline">
                        {{ item.assignmentTitle }}
                      </h3>
                    </div>
                    <div class="d-block">
                      <div>
                        <span>
                          <span class="mr-3">
                            {{ $t('form.datatype') }}:
                            <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 4"
                              >{{ $t('content.assignment_item.manual_input') }}
                            </strong>
                            <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                            <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                            <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
                          </span>
                          |
                          <span class="mr-3">
                            {{ $t('content.available_from') }}:
                            <strong>{{ item.availableFromDate }}</strong>
                            <strong v-if="item.availableFromDate === null">-</strong></span
                          >
                          |
                          <span v-if="item.lock === false" class="ml-3 mr-3"
                            >{{ $t('content.lock_schedule') }} :

                            <strong style="color: #E02020;">{{ item.availableUntilDate }}</strong>
                            <strong style="color: #E02020;" v-if="item.availableUntilDate === null">-</strong>
                          </span>
                          <span v-if="item.lock === true" class="ml-3 mr-3"
                            >{{ $t('content.unlock_schedule') }} :
                            <strong style="color: #6DD400;">{{ item.availableUntilDate }}</strong>
                            <strong style="color: #6DD400;" v-if="item.availableUntilDate === null">-</strong>
                          </span>

                          |

                          <span class="ml-3 mr-3"
                            >{{ $t('content.due_date') }} :
                            <strong style="color:#FA6400;">{{ item.dueDate }}</strong>
                            <strong style="color:#FA6400;" v-if="item.dueDate === null">-</strong>
                          </span>

                          |
                          <span class="ml-3 mr-3">
                            <span>{{ $t('menu.score') }} : </span>
                            <strong style="color:#00bf63;"> {{ item.totalPoint }}</strong>
                          </span>
                          |

                          <span class="ml-3 mr-1">{{ $t('information') }}</span
                          >:
                          <strong style="color:#6DD400;" v-if="item.published === true">{{ $t('content.publish_score') }}</strong>
                          <strong style="color:#E02020;" v-else> {{ $t('content.unpublish_score') }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="d-flex"></div>
                  </v-col>
                  <v-col md="1">
                    <template>
                      <div class="pa-5">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <span dark v-bind="attrs" v-on="on">
                              <svg-icon icon="ic-moreaction-black" class="mt-1" />
                            </span>
                          </template>
                          <v-list>
                            <v-list-item v-if="permissionButton('ROLE_ASSIGNMENT_VIEW') || permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')">
                              <v-list-item-title class="text-dropdown" @click="showDetail(item)">{{ $t('view') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="
                                (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_UPDATE')) ||
                                  (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_LITE_UPDATE'))
                              "
                            >
                              <v-list-item-title class="text-dropdown" @click="editDetail(item)">{{ $t('edit') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="
                                (item.published === false && type === 'teacher' && permissionButton('ROLE_ASSIGNMENT_DELETE')) ||
                                  (item.published === false && type === 'teacher' && permissionButton('ROLE_ASSIGNMENT_LITE_DELETE'))
                              "
                            >
                              <v-list-item-title class="text-dropdown-delete" @click="dialogdeleteAssign(item)">{{
                                $t('table.delete')
                              }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="
                                (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_UPDATE')) ||
                                  (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_LITE_UPDATE'))
                              "
                            >
                              <v-list-item-title>
                                <v-btn text class="text-dropdown" v-if="item.published === false" :loading="loading" @click="submitPublish(item)">{{
                                  $t('content.publish_score')
                                }}</v-btn>
                                <v-btn text class="text-dropdown" v-if="item.published === true" :loading="loading" @click="submitPublish(item)">{{
                                  $t('content.unpublish_score')
                                }}</v-btn>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                  </v-col>
                </v-row>

                <!-- old feature -->
                <!-- <div class="assignment-item">
                  <div class="ml-4 mr-10">
                    <svg-icon v-if="item.lock === true" icon="lock" class="red--text" />
                    <svg-icon v-if="item.lock === false" icon="gembok" />
                  </div>
                  <div class="assignment-item-icon ml-4 mr-10">
                    <svg-icon icon="assigment-ic" />
                  </div>
                  <div class="assignment-item-section ml-4">
                    <strong>{{ item.assignmentTitle }}</strong>
                  </div>
                  <div class="assignment-item-section ml-4">
                    <span class="assignment-item-section-title">{{ $t('content.assignment_type') }}</span>
                    <strong v-if="item.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
                    <strong v-if="item.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                    <strong v-if="item.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                    <strong v-if="item.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
                  </div>
                  <div class="assignment-item-section ml-4">
                    <span class="assignment-item-section-title">{{ $t('content.available_from') }}</span>
                    <strong style="color:#00BF63;">{{ item.availableFromDate }}</strong>
                    <strong style="color:#00BF63;" v-if="item.availableFromDate === null">-</strong>
                  </div>

                  <div class="assignment-item-section ml-4" v-if="item.lock === false">
                    <span class="assignment-item-section-title">{{ $t('content.lock_schedule') }}</span>
                    <strong style="color: #E02020;">{{ item.availableUntilDate }}</strong>
                    <strong style="color: #E02020;" v-if="item.availableUntilDate === null">-</strong>
                  </div>
                  <div class="assignment-item-section ml-4" v-if="item.lock === true">
                    <span class="assignment-item-section-title">{{ $t('content.unlock_schedule') }}</span>
                    <strong style="color: #6DD400;">{{ item.availableUntilDate }}</strong>
                    <strong style="color: #6DD400;" v-if="item.availableUntilDate === null">-</strong>
                  </div>
                  <div class="assignment-item-section ml-4">
                    <span class="assignment-item-section-title">{{ $t('content.due_date') }}</span>
                    <strong style="color:#FA6400;">{{ item.dueDate }}</strong>
                    <strong style="color:#FA6400;" v-if="item.dueDate === null">-</strong>
                  </div>
                  <div class="assignment-item-section ml-4">
                    <span class="assignment-item-section-title">{{ $t('menu.score') }}</span>
                    <strong> {{ item.totalPoint }}</strong>
                  </div>
                  <div class="assignment-item-section ml-4">
                    <span class="assignment-item-section-title">{{ $t('information') }}</span>
                    <strong style="color:#6DD400;" v-if="item.published === true">{{ $t('content.publish_score') }}</strong>

                    <strong style="color:#E02020;" v-else> {{ $t('content.unpublish_score') }}</strong>
                  </div>
                  <div class="assignment-item-section">
                    <template>
                      <div class="ml-4">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <span dark v-bind="attrs" v-on="on">
                              <svg-icon icon="ic-moreaction-black" class="mt-1" />
                            </span>
                          </template>
                          <v-list>
                            <v-list-item>
                              <v-list-item-title class="text-dropdown" @click="showDetail(item)">{{ $t('view') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title class="text-dropdown" @click="editDetail(item)">{{ $t('edit') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="item.published === false">
                              <v-list-item-title class="text-dropdown-delete" @click="dialogdeleteAssign(item)">{{
                                $t('table.delete')
                              }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title class="text-dropdown" v-if="item.published === false" @click="submitPublish(item)">{{
                                $t('content.publish_score')
                              }}</v-list-item-title>
                              <v-list-item-title class="text-dropdown" v-if="item.published === true" @click="submitPublish(item)">{{
                                $t('content.unpublish_score')
                              }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                  </div>
                </div> -->
              </div>
              <NoData v-if="!grup.assignments.length" />
            </div>
          </template>
        </slide-box>

        <!-- Dialog Delete Grup -->
        <v-dialog v-model="dialogDelete" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
            <v-card-text>{{ $t('delete_message') }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
              <v-btn text :loading="loading" @click="deleteGrup(grup.assignmentGroupId)">{{ $t('aggree') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Dialog Delete Assignment -->
        <v-dialog v-model="dialogDeleteAssignment" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
            <v-card-text>{{ $t('delete_message') }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelDeleteAssign">{{ $t('disagree') }}</v-btn>
              <v-btn text :loading="loading" @click="deleteDetail">{{ $t('aggree') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>

    <!-- view list box -->
    <div v-if="viewItem === 1 && filterType === 2">
      <v-card class="mb-5" v-for="item in dateList" :key="item.assignmentId" :item="item">
        <div class="assignment-content">
          <div>
            <!-- new feature -->
            <v-row class="border-item">
              <v-col md="1" align="center">
                <div class="pa-5">
                  <svg-icon v-if="item.lock === true" icon="lock" class="red--text assigment-icon" />
                  <svg-icon v-if="item.lock === false" icon="gembok" class="assigment-icon" />
                </div>
              </v-col>
              <v-col md="10" class="mt-5">
                <div class="d-block mb-2">
                  <h3 class="d-inline">
                    {{ item.assignmentTitle }}
                  </h3>
                </div>
                <div class="d-block">
                  <div>
                    <span>
                      <span class="mr-3">
                        {{ $t('form.datatype') }}:
                        <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
                        <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                        <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                        <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
                      </span>
                      |
                      <span class="mr-3">
                        {{ $t('content.available_from') }}:
                        <strong>{{ item.availableFromDate }}</strong>
                        <strong v-if="item.availableFromDate === null">-</strong></span
                      >
                      |
                      <span v-if="item.lock === false" class="ml-3 mr-3"
                        >{{ $t('content.lock_schedule') }} :

                        <strong style="color: #E02020;">{{ item.availableUntilDate }}</strong>
                        <strong style="color: #E02020;" v-if="item.availableUntilDate === null">-</strong>
                      </span>
                      <span v-if="item.lock === true" class="ml-3 mr-3"
                        >{{ $t('content.unlock_schedule') }} :
                        <strong style="color: #6DD400;">{{ item.availableUntilDate }}</strong>
                        <strong style="color: #6DD400;" v-if="item.availableUntilDate === null">-</strong>
                      </span>

                      |

                      <span class="ml-3 mr-3"
                        >{{ $t('content.due_date') }} :
                        <strong style="color:#FA6400;">{{ item.dueDate }}</strong>
                        <strong style="color:#FA6400;" v-if="item.dueDate === null">-</strong>
                      </span>

                      |
                      <span class="ml-3 mr-3">
                        <span>{{ $t('menu.score') }} : </span>
                        <strong style="color:#00bf63;"> {{ item.totalPoint }}</strong>
                      </span>
                      |

                      <span class="ml-3 mr-1">{{ $t('information') }}</span
                      >:
                      <strong style="color:#6DD400;" v-if="item.published === true">{{ $t('content.publish_score') }}</strong>
                      <strong style="color:#E02020;" v-else> {{ $t('content.unpublish_score') }}</strong>
                    </span>
                  </div>
                </div>
                <div class="d-flex"></div>
              </v-col>
              <v-col md="1">
                <template>
                  <div class="pa-5">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span dark v-bind="attrs" v-on="on">
                          <svg-icon icon="ic-moreaction-black" class="mt-1" />
                        </span>
                      </template>
                      <v-list>
                        <v-list-item v-if="permissionButton('ROLE_ASSIGNMENT_VIEW') || permissionButton('ROLE_ASSIGNMENT_LITE_VIEW')">
                          <v-list-item-title class="text-dropdown" @click="showDetail(item)">{{ $t('view') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_UPDATE')) ||
                              (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_LITE_UPDATE'))
                          "
                        >
                          <v-list-item-title class="text-dropdown" @click="editDetail(item)">{{ $t('edit') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.published === false && type === 'teacher' && permissionButton('ROLE_ASSIGNMENT_DELETE')">
                          <v-list-item-title class="text-dropdown-delete" @click="dialogdeleteAssign(item)">{{
                            $t('table.delete')
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_UPDATE')) ||
                              (type !== 'school-advisor' && permissionButton('ROLE_ASSIGNMENT_LITE_UPDATE'))
                          "
                        >
                          <v-list-item-title>
                            <v-btn text class="text-dropdown" v-if="item.published === false" :loading="loading" @click="submitPublish(item)">{{
                              $t('content.publish_score')
                            }}</v-btn>
                            <v-btn text class="text-dropdown" v-if="item.published === true" :loading="loading" @click="submitPublish(item)">{{
                              $t('content.unpublish_score')
                            }}</v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </div>

    <!-- view grade box -->
    <div v-if="viewItem === 2">
      <v-card class="pa-5 mb-10">
        <div class="d-flex align-center justify-space-between mb-5">
          <h3 class="app-section-title">{{ $t('content.student_list') }}</h3>
          <div>
            <v-text-field v-model="searchBox" :label="$t('search')">
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
          </div>
        </div>
        <div class="attendance-scroller">
          <table class="attendance-table">
            <thead>
              <tr>
                <th width="100" class="attendance-sticky">
                  <div>{{ $t('form.name') }}</div>
                </th>
                <th width="100" v-for="items in gradeForm.gradeBook[0].assignments" :key="items.assignmentId">
                  <div>{{ items.assignmentTitle }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in gradeForm.gradeBook" :key="item.studentId">
                <td class="attendance-sticky">
                  <div class="d-flex align-center" style="height:40px">{{ item.fullName }}</div>
                </td>
                <td class="attendance-sticky" v-for="att in item.assignments" :key="att.assignmentId">
                  <div class="d-flex align-center" style="height:40px">
                    <v-text-field :disabled="att.submitted === false" v-model="att.score" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>
    </div>

    <div class="d-flex justify-end align-center" v-if="viewItem === 2 && type === 'teacher'">
      <v-btn color="primary" class="btn-primary-custom mr-3" @click="viewItem = 1" outlined>{{ $t('back') }}</v-btn>
      <v-btn
        color="primary"
        v-if="permissionButton('ROLE_ASSIGNMENT_UPDATE') || permissionButton('ROLE_ASSIGNMENT_LITE_UPDATE')"
        :loading="loading"
        class="btn-primary-custom"
        type="submit"
        @click="submitGradeBook"
      >
        {{ $t('submit') }}
      </v-btn>
    </div>

    <!-- Dialog Create -->
    <v-dialog v-model="dialogGroup" width="500" persistent>
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t(edit ? 'content.edit_grup' : 'content.add_grup') }}
        </v-card-title>
        <div class="pa-4">
          <form-group :name="$t('content.group_name_assignment')" no-gutter :validator="$v.form.groupName">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-model="form.groupName"
                v-bind="attrs"
                @input="$v.form.groupName.$touch()"
                @blur="$v.form.groupName.$touch()"
                :label="$t('content.group_name_assignment')"
              />
            </template>
          </form-group>

          <form-group :name="$t('content.group_weight_assignment')" no-gutter>
            <template slot-scope="{ attrs }">
              <v-text-field
                v-model="form.assignmentPercent"
                type="number"
                @keydown="nameKeydown($event)"
                @paste.prevent="onPasteWeightAssignment($event)"
                oninput="if(Number(this.value) > Number(100)) this.value = 100;"
                :min="0"
                v-bind="attrs"
                :label="$t('content.group_weight_assignment')"
              />
            </template>
          </form-group>
        </div>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="grupClose">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" v-if="validGrup === 'Ungroup' && grupList[0].assignments.length >= 1" @click="popUpClose">{{
            $t(edit ? 'save' : 'submit')
          }}</v-btn>
          <v-btn color="primary" v-if="validGrup === 'Ungroup' && grupList[0].assignments.length === 0" :loading="loading" @click="submitGrup">{{
            $t(edit ? 'save' : 'submit')
          }}</v-btn>
          <v-btn color="primary" v-if="validGrup !== 'Ungroup'" :loading="loading" @click="submitGrup">{{ $t(edit ? 'save' : 'submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Move -->
    <v-dialog v-model="dialogPopUp" persistent max-width="607">
      <v-card>
        <div class="d-flex justify-center"><img src="@/assets/images/ic-alert.png" class="mt-5 mb-5" /></div>
        <v-card-title class="headline d-flex justify-center">{{ $t('content.assignment_grup_title') }}</v-card-title>
        <v-card-text>{{ $t('content.assignment_grup_content') }}? </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogPopUp = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="loading" @click="moveGroupCreate">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { maxLength, required } from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validators';
import BaseTitle from '@/components/base/Title';
import SlideBox from '@/components/SlideBox';
import NoData from '@/components/table/NoData';

export default {
  name: 'AssignmentIndex',
  components: {
    BaseTitle,
    SlideBox,
    NoData
  },
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      items: 'Assignment/items',
      user: 'Auth/user',
      role: 'Auth/currentRole',
      permission: 'Auth/permission',
      nameCourse: 'CourseList/nameCourse'
    }),
    // filterGrup() {
    //   if (this.search) {
    //     return this.grupList.filter(item => {
    //       return item.assignmentGroupName.startsWith(this.search);
    //     });
    //   } else {
    //     return this.grupList;
    //   }
    // },
    validGrup() {
      var grupName = this.grupList?.[0]?.assignmentGroupName;
      return grupName;
    },
    viewType() {
      return [
        { value: 1, text: this.$t('content.list') },
        { value: 2, text: this.$t('content.grade_box') }
      ];
    },
    dropDown() {
      return [{ title: this.$t('edit') }, { title: this.$t('table.delete') }];
    }
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.form.schoolId = value.schoolId;
      }
    }
  },
  validations: {
    form: {
      groupName: { required, alphaSpace, maxLength: maxLength(30) }
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateAssignment({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_assignment') });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    }
  },
  data: () => ({
    loading: false,
    loadingButton: false,
    search: '',
    searchBox: '',
    edit: false,
    dialogGroup: false,
    dialogPopUp: false,
    dialogDelete: false,
    dialogDeleteAssignment: false,
    dataClass: '',
    itemAssignment: '',
    filterType: 1,
    dateList: [],
    grupList: [],
    gradeForm: {
      gradeBook: []
    },
    viewItem: 1,
    form: {
      id: '',
      groupName: '',
      assignmentPercent: '',
      schoolId: ''
    },
    checkExport: '',
    titleData: ''
  }),
  methods: {
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    searchFilter(e) {
      if (e) {
        const { classId, courseId } = this.$route.params;
        this.$store
          .dispatch('Assignment/fetchListSearch', {
            classId,
            courseId,
            search: e,
            classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
          })
          .then(res => (this.grupList = res))
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      } else {
        this.getData();
      }
    },
    searchFilterList(e) {
      if (e) {
        const { classId, courseId } = this.$route.params;
        this.$store
          .dispatch('Assignment/fetchListFilterSearch', {
            classId,
            courseId,
            search: e,
            classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
          })
          .then(res => (this.dateList = res))
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      } else {
        this.getData();
      }
    },
    submitPublish(item) {
      var detailPublished = false;
      var assignmentId = item.assignmentId;
      if (item.published === true) {
        this.loading = true;
        this.$store
          .dispatch(`Assignment/updatePublish`, { assignmentId, published: false, detailPublished })
          .then(() => {
            this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.save_publish') });
            this.getData();
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.loading = false));
      } else {
        this.loading = true;
        this.$store
          .dispatch(`Assignment/updatePublish`, { assignmentId, published: true, detailPublished })
          .then(() => {
            this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.save_unpublish') });
            this.getData();
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.loading = false));
      }
    },
    nameKeydown(e) {
      const blockedKeys = ['e', 'E', '+', '-'];

      if (blockedKeys.includes(e.key)) {
        e.preventDefault();
      }
    },
    onPasteWeightAssignment(e) {
      const pasted = e.clipboardData.getData('text');

      if (!/^\d+$/.test(pasted)) {
        return;
      }

      const value = Number(pasted);
      this.form.assignmentPercent = value > 100 ? 100 : value;
    },
    exportCheck() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Assignment/exportCheck', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => (this.checkExport = res.published))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    popUpClose() {
      this.dialogGroup = false;
      this.dialogPopUp = true;
    },
    getData() {
      const { classId, courseId } = this.$route.params;
      this.loadingButton = true;
      this.$store
        .dispatch('Assignment/fetchList', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => (this.grupList = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingButton = false));
    },
    getDataList() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Assignment/fetchListFilter', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => (this.dateList = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getGradeBox() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Assignment/gradeBox', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => (this.gradeForm.gradeBook = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    submitGrup() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      this.loading = true;
      const { classId, courseId, id } = this.$route.params;
      this.$store
        .dispatch(`Assignment/${this.edit ? 'updateGrup' : 'saveGrup'}`, {
          id,
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          ...this.form
        })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.dialogGroup = false;
          this.form.id = null;
          this.form.groupName = null;
          this.form.assignmentPercent = null;
          this.edit = false;
          this.viewItem = 1;
          this.$v.$reset();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    submitGradeBook() {
      this.loading = true;
      this.$store
        .dispatch(`Assignment/saveGradeBook`, { ...this.gradeForm })
        .then(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Save Grade Book Success' });
          this.getGradeBox();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    moveGroupCreate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      this.loading = true;
      const { classId, courseId, id } = this.$route.params;
      this.$store
        .dispatch(`Assignment/saveGrupMove`, {
          id,
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          ...this.form
        })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.dialogPopUp = false;
          this.form.id = null;
          this.form.groupName = null;
          this.form.assignmentPercent = null;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    editGrup(item) {
      this.edit = true;
      this.form.id = item.assignmentGroupId;
      this.form.groupName = item.assignmentGroupName;
      this.form.assignmentPercent = item.assignmentPercent;
      this.dialogGroup = true;
    },
    grupClose() {
      this.form.id = null;
      this.form.groupName = null;
      this.form.assignmentPercent = null;
      this.edit = false;
      this.dialogGroup = false;

      this.$v.$reset();
    },
    deleteGrup(id) {
      this.loading = true;
      this.$store
        .dispatch('Assignment/deleteGrup', id)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    showDetail({ assignmentId }) {
      if (this.type === 'teacher') {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'TeacherAssignmentDetail', params: { assignmentId } });
        } else {
          this.$router.push({ name: 'TeacherAssignmentSectionDetail', params: { assignmentId } });
        }
      } else {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'AdvisorAssignmentDetail', params: { assignmentId } });
        } else {
          this.$router.push({ name: 'AdvisorSectionAssignmentDetail', params: { assignmentId } });
        }
      }
    },
    editDetail({ assignmentId }) {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentEdit', params: { assignmentId } });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionEdit', params: { assignmentId } });
      }
    },
    dialogdeleteAssign(item) {
      this.itemAssignment = item;
      this.dialogDeleteAssignment = true;
    },
    cancelDeleteAssign() {
      this.dialogDeleteAssignment = false;
      this.itemAssignment = null;
    },
    deleteDetail() {
      this.loading = true;
      this.$store
        .dispatch('Assignment/deleteAssignment', this.itemAssignment.assignmentId)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.dialogDeleteAssignment = false;
          this.itemAssignment = null;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    addAssignment() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentCreate' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionCreate' });
      }
    },
    getExport() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Assignment/export', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `teacher_report_assignment_${this?.dataClass?.classroomName}_${localStorage.getItem('courseName')}.xlsx`;
          link.click();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    }
  },
  created() {
    this.exportCheck();
    this.getDataClass();
    this.getData();
    this.getGradeBox();
    this.getDataList();
  }
};
</script>

<style lang="scss" scoped>
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.section-footer {
  border-radius: 4px 4px 0 0;
  background: #e7f5ff;
}
.header-circle {
  background-color: #00bf63;
  border: 1px solid #ffffff;
  border-radius: 8px;
  width: 110px;
  height: 23px;
}
.header-circle-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  margin-left: 10px;
}
.border-item {
  border-bottom: 1px solid #dedede;
}
.assignment-item {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  border-bottom: 1px solid #dedede;
  // &:last-child {
  //   border-bottom: 0;
  //   // border-bottom: 1px solid #dedede;
  // }

  &-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    text-align: center;
    line-height: 24px;
    margin-right: 12px;

    svg {
      margin-top: 3px;
    }
  }

  &-section {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &-title {
      display: block;
    }

    strong {
      color: #6d6d6d;
    }
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 25%;
      margin-bottom: 0;
    }
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}

.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 100px;
        height: $height;
        background: #00bf63;

        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}

.assigment-icon {
  width: 30px;
  height: 30px;
}
</style>
